export const getNameFromFirstLast = (obj) => {
  const { lastNameKata, firstNameKata, lastNameKanji, firstNameKanji } = obj;
  return `${lastNameKata} ${firstNameKata}`;
};
